import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/logo.svg" 
                alt="bHyyve Logo" 
                className="w-32 h-32 object-contain"
              />
              <span className="text-2xl font-bold">bHyyve</span>
            </div>
            <p className="text-white/70 leading-relaxed">
              The only place for everything.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-yellow-400">Quick Links</h3>
            <ul className="space-y-3">
              <li><a href="#services" className="text-white/70 hover:text-yellow-400 transition-colors">Services</a></li>
              <li><a href="#download" className="text-white/70 hover:text-yellow-400 transition-colors">Download App</a></li>
              <li><a href="/appbeta100" className="text-white/70 hover:text-yellow-400 transition-colors">Beta Program</a></li>
              <li><a href="/freegyyfts" className="text-white/70 hover:text-yellow-400 transition-colors">Free Gyyfts</a></li>
              <li><a href="/survey" className="text-white/70 hover:text-yellow-400 transition-colors">Take Our Survey 🎁</a></li>
              <li><a href="/vendoronboarding" className="text-white/70 hover:text-yellow-400 transition-colors">Vendor Onboarding 🐝</a></li>
              <li><a href="/foundingvendoroffer" className="text-white/70 hover:text-yellow-400 transition-colors">Founding Vendor Offer ✨</a></li>
              <li><a href="/yourhyyve" className="text-white/70 hover:text-yellow-400 transition-colors">Your Hyyve Portal</a></li>
              <li><a href="#testimonials" className="text-white/70 hover:text-yellow-400 transition-colors">Testimonials</a></li>
              <li><a href="#contact" className="text-white/70 hover:text-yellow-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-yellow-400">Company</h3>
            <ul className="space-y-3">
              <li><a href="/about" className="text-white/70 hover:text-yellow-400 transition-colors">About Us</a></li>
              <li><a href="/careers" className="text-white/70 hover:text-yellow-400 transition-colors">Careers</a></li>
              <li><a href="/privacy" className="text-white/70 hover:text-yellow-400 transition-colors">Privacy Policy</a></li>
              <li><a href="/terms" className="text-white/70 hover:text-yellow-400 transition-colors">Terms of Service</a></li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-yellow-400">Connect With Us</h3>
            <div className="flex gap-4 mb-6">
              <a href="#" className="bg-white/10 hover:bg-yellow-400 p-3 rounded-lg transition-all duration-200 group">
                <Facebook className="text-white group-hover:text-black transition-colors" size={20} />
              </a>
              <a href="#" className="bg-white/10 hover:bg-yellow-400 p-3 rounded-lg transition-all duration-200 group">
                <Twitter className="text-white group-hover:text-black transition-colors" size={20} />
              </a>
              <a href="#" className="bg-white/10 hover:bg-yellow-400 p-3 rounded-lg transition-all duration-200 group">
                <Instagram className="text-white group-hover:text-black transition-colors" size={20} />
              </a>
              <a href="#" className="bg-white/10 hover:bg-yellow-400 p-3 rounded-lg transition-all duration-200 group">
                <Linkedin className="text-white group-hover:text-black transition-colors" size={20} />
              </a>
            </div>
            <div className="flex items-center gap-2 text-white/70">
              <Mail size={18} />
              <span>support@bhyyve.com</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {currentYear} bHyyve. All rights reserved.
            </p>
            <p className="text-white/60 text-sm">
              Made with <span className="text-yellow-400">❤</span> for our customers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;